/*
  Kalemsy 4 Ekim 2026: sözlük her yerde.
  Ürün açıklamasında ve yazı metninde geçen sözlük teriminin ilk geçtiği yeri dokunulabilir yapar; dokununca terimin
  tanımı ve sözlükteki maddesine bağlantı açılır.
  Veri assets/kls-terimler.json (sözlük şablonundan üretilir):
    k: [sözcük, çapa] listesi, öncelik sırasıyla; d: çapa -> { a: ad, t: düz metin tanım }.
  Kurallar: sayfa başına en çok 5 terim, paragraf başına 1, her terim bir kez. Bağlantı, düğme, başlık, görsel
  altyazısı, ürün kartı (.kyu), içindekiler ve "Bu yazıdaki terimler" kutusunun içine girilmez. Ürün sayfasında
  ürün başlığında geçen terim işaretlenmez. Sözlüğün "Versatil kalem" konusundaki terimler (uç kalınlığı, model kodu,
  uç sertliği...) versatil kalem ucunu anlatır: ürün sayfasında yalnız versatil, uç, kurşun ve çok işlevli kalemde,
  yazıda yalnız metin dolma kalemi versatil/mekanik kalemden çok anmıyorsa işaretlenir (4 Ekim kontrolü: Custom 74
  sayfasında "Uç kalınlığı notu" dolma kalem ucunu, "Model kodu" ürün kodunu anlatıyordu). Sözcük kelime başında aranır, son kelime Türkçe ekiyle birlikte
  işaretlenir ("gölgelenmesi"). Büyük-küçük harf ve I/ı farkı yok sayılır.
  Veri sayfa boştayken çekilir (requestIdleCallback); ilk çizimi bekletmez. Tema kökü 10 px: ölçüler piksel.
  Kullanım: layout/theme.liquid, ürün ve yazı sayfalarında defer; data-veri, data-sozluk, ürün sayfasında data-baslik
  ve data-tur (ürün türü).
*/
(function () {
  var betik = document.currentScript;
  if (!betik || !betik.dataset.veri) return;
  var VERI = betik.dataset.veri;
  var SOZLUK = betik.dataset.sozluk || '/pages/kalem-sozlugu';
  var BASLIK = betik.dataset.baslik || '';
  var TUR = betik.dataset.tur;
  var VERSATIL_TUR = ['versatil kalem', 'kalem ucu', 'kurşun kalem', 'multifonksiyonel kalem'];
  var KAPSAM = '.product-description.rte, .article__content.rte';
  var ATLA = 'a, button, h1, h2, h3, h4, h5, h6, script, style, figcaption, .kyu, .kls-terim, .kls-icindekiler, [data-kls-tt-yok]';
  var BLOK = 'p, li, td, th, dd, dt, blockquote';
  var EN_COK = 5;
  var veri = null;
  var sayac = 0;

  function katla(s) {
    return s.toLocaleLowerCase('tr').replace(/ı/g, 'i');
  }

  function harf(c) {
    return /[0-9a-zÀ-ɏ]/i.test(c);
  }

  function bul(metin, soz) {
    var i = metin.indexOf(soz);
    while (i !== -1) {
      if (i === 0 || !harf(metin.charAt(i - 1))) {
        var son = i + soz.length;
        while (son < metin.length && harf(metin.charAt(son))) son++;
        return [i, son];
      }
      i = metin.indexOf(soz, i + 1);
    }
    return null;
  }

  function stil() {
    var s = document.createElement('style');
    s.textContent =
      '.kls-tt-k{position:relative}' +
      '.kls-tt{font:inherit;color:inherit;background:none;border:0;border-radius:0;padding:0;margin:0;min-height:0;' +
      'letter-spacing:inherit;text-transform:none;cursor:help;text-decoration:underline dotted;text-decoration-thickness:1px;' +
      'text-underline-offset:3px;text-decoration-color:rgba(var(--text-color) / .6);display:inline}' +
      '.kls-tt[aria-expanded="true"]{text-decoration-style:solid}' +
      '.kls-tt:focus-visible{outline:2px solid rgb(var(--text-color));outline-offset:2px}' +
      '.kls-tt-kutu{position:absolute;top:calc(100% + 6px);left:0;z-index:30;display:block;width:300px;' +
      'max-width:calc(100vw - 32px);box-sizing:border-box;padding:12px 14px;border:1px solid rgba(var(--text-color) / .14);' +
      'border-radius:8px;background:rgb(var(--bg-color, 255 255 255));color:rgb(var(--text-color));' +
      'box-shadow:0 6px 24px rgba(0,0,0,.14);font-size:14px;line-height:1.45;font-weight:400;font-style:normal;' +
      'text-align:left;white-space:normal;text-transform:none;letter-spacing:normal}' +
      '.kls-tt-ad{display:block;margin-bottom:4px;font-weight:700}' +
      '.kls-tt-tanim{display:block}' +
      '.kls-tt-git{display:inline-block;margin-top:8px;font-weight:700;color:inherit;text-decoration:underline;text-underline-offset:3px}';
    document.head.appendChild(s);
  }

  function kapat(odak) {
    var acik = document.querySelectorAll('.kls-tt[aria-expanded="true"]');
    for (var i = 0; i < acik.length; i++) {
      var d = acik[i];
      d.setAttribute('aria-expanded', 'false');
      var kutu = document.getElementById(d.getAttribute('aria-controls'));
      if (kutu) kutu.remove();
      d.removeAttribute('aria-controls');
      if (odak) d.focus();
    }
  }

  function ac(e) {
    var d = e.currentTarget;
    var acikti = d.getAttribute('aria-expanded') === 'true';
    kapat(false);
    if (acikti) return;
    var capa = d.dataset.capa;
    var bilgi = veri.d[capa];
    if (!bilgi) return;
    var kutu = document.createElement('span');
    kutu.className = 'kls-tt-kutu';
    kutu.id = 'kls-tt-' + (++sayac);
    kutu.setAttribute('role', 'dialog');
    kutu.setAttribute('aria-label', bilgi.a);
    var ad = document.createElement('span');
    ad.className = 'kls-tt-ad';
    ad.textContent = bilgi.a;
    var tanim = document.createElement('span');
    tanim.className = 'kls-tt-tanim';
    tanim.textContent = bilgi.t;
    var git = document.createElement('a');
    git.className = 'kls-tt-git';
    git.href = SOZLUK + '#' + capa;
    git.textContent = 'Sözlükte aç';
    kutu.appendChild(ad);
    kutu.appendChild(tanim);
    kutu.appendChild(git);
    d.parentNode.appendChild(kutu);
    d.setAttribute('aria-expanded', 'true');
    d.setAttribute('aria-controls', kutu.id);
    var kap = d.parentNode.getBoundingClientRect();
    var en = kutu.offsetWidth;
    var sol = 0;
    if (kap.left + en > window.innerWidth - 16) sol = window.innerWidth - 16 - en - kap.left;
    if (kap.left + sol < 16) sol = 16 - kap.left;
    kutu.style.left = sol + 'px';
  }

  function sar(dugum, bas, son, capa) {
    var orta = dugum.splitText(bas);
    orta.splitText(son - bas);
    var k = document.createElement('span');
    k.className = 'kls-tt-k';
    var d = document.createElement('button');
    d.type = 'button';
    d.className = 'kls-tt';
    d.setAttribute('aria-expanded', 'false');
    d.dataset.capa = capa;
    d.textContent = orta.nodeValue;
    k.appendChild(d);
    orta.parentNode.replaceChild(k, orta);
    d.addEventListener('click', ac);
  }

  function adet(metin, soz) {
    return metin.split(soz).length - 1;
  }

  function versatilBaglam(kaplar) {
    if (TUR !== undefined) return VERSATIL_TUR.indexOf(TUR.toLocaleLowerCase('tr')) !== -1;
    var metin = '';
    for (var i = 0; i < kaplar.length; i++) metin += ' ' + katla(kaplar[i].textContent);
    var dolma = adet(metin, 'dolma kalem');
    var versatil = adet(metin, 'versatil') + adet(metin, 'mekanik kalem') + adet(metin, 'uçlu kalem');
    return dolma <= versatil;
  }

  function isaretle() {
    var kaplar = document.querySelectorAll(KAPSAM);
    var baslik = katla(BASLIK);
    var versatil = versatilBaglam(kaplar);
    var sozler = veri.k.filter(function (x) {
      if (baslik && baslik.indexOf(x[0]) !== -1) return false;
      if (!versatil && veri.d[x[1]] && veri.d[x[1]].g === 'Versatil kalem') return false;
      return true;
    });
    var kullanilan = {};
    var bloklar = [];
    var sayi = 0;
    for (var i = 0; i < kaplar.length && sayi < EN_COK; i++) {
      var yuruyen = document.createTreeWalker(kaplar[i], NodeFilter.SHOW_TEXT, {
        acceptNode: function (n) {
          if (!n.nodeValue || n.nodeValue.length < 4) return NodeFilter.FILTER_REJECT;
          var e = n.parentElement;
          if (!e || e.closest(ATLA)) return NodeFilter.FILTER_REJECT;
          return NodeFilter.FILTER_ACCEPT;
        }
      });
      var dugumler = [];
      while (yuruyen.nextNode()) dugumler.push(yuruyen.currentNode);
      for (var j = 0; j < dugumler.length && sayi < EN_COK; j++) {
        var n = dugumler[j];
        var blok = n.parentElement.closest(BLOK);
        if (blok && bloklar.indexOf(blok) !== -1) continue;
        var metin = katla(n.nodeValue);
        if (metin.length !== n.nodeValue.length) continue;
        for (var s = 0; s < sozler.length; s++) {
          if (kullanilan[sozler[s][1]]) continue;
          var yer = bul(metin, sozler[s][0]);
          if (yer) {
            sar(n, yer[0], yer[1], sozler[s][1]);
            kullanilan[sozler[s][1]] = true;
            if (blok) bloklar.push(blok);
            sayi++;
            break;
          }
        }
      }
    }
    if (sayi) {
      document.addEventListener('click', function (e) {
        if (!e.target.closest('.kls-tt-k')) kapat(false);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') kapat(true);
      });
    }
  }

  function basla() {
    if (!document.querySelector(KAPSAM)) return;
    fetch(VERI)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || !j.k) return;
        veri = j;
        stil();
        isaretle();
      })
      .catch(function () {});
  }

  if ('requestIdleCallback' in window) {
    requestIdleCallback(basla, { timeout: 3000 });
  } else {
    setTimeout(basla, 1500);
  }
})();
